/**
 * Port von `IwmSidebarTriggerBestellpositionContainer.razor`: Die Komponente rendert
 * nichts, sondern öffnet beim Einhängen die Container-Sidebar der Bestellpositions-View.
 * Im Altclient übernimmt das der Singleton `SbOrderPositionContainerService`.
 */

import { useEffect } from 'react';

import { useOrderPositionContainerSidebar } from '@/components/sidebars/OrderPositionContainerSidebarContext';

export interface ContainerSidebarTriggerProps {
  containerId: number;
}

export function ContainerSidebarTrigger(props: ContainerSidebarTriggerProps) {
  const { containerId } = props;
  const sidebar = useOrderPositionContainerSidebar();

  useEffect(() => {
    if (containerId > 0) sidebar.show(containerId);
  }, [containerId, sidebar]);

  return null;
}

export default ContainerSidebarTrigger;
